import { Language } from '../types/PluginData';

type Dictionary = {
    [key: string]: any
}

export const getTranslatedObject = <DataType extends Dictionary>(
    object: DataType,
    language?: Language | null
) => {
    if (!language) return object

    let data: DataType = {...object}

    for (const key in object) {
        if (
            key + '_multi' in object &&
            typeof object[key + '_multi'] === 'string' &&
            isValidJSON(object[key + '_multi'])
        ) {
            try {
                const translations = JSON.parse(object[key + '_multi']) as Dictionary
                if (language.jtl in translations) {
                    data[key] = translations[language.jtl]
                }
            }
            catch {
                console.log('error translation', object[key + '_multi'])
            }
        }
    }

    return data
}

const isValidJSON = (str:string) => {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
};